customElements.define('component-help-center', class GladlyHelpCenter extends HTMLElement {
  constructor() {
    super();
    this.props = {
      formEndpoint: this.dataset.formEndpoint,
      originalTitle: this.dataset.originalTitle,
    }

    window.addEventListener('load', () => {
      // Redirect site search to search results page
      if (window.location.search.includes('?q=')) {
        window.location.href = `https://thirdlove.com/search${window.location.search}`;
      }
      // Show contact form or help center
      if (window.location.search.includes('?contact-form')) {
        document.querySelector('.gladly-contact').style.display = 'flex';
        document.querySelector('component-help-center').style.display = 'none';
      } else {
        document.querySelector('component-help-center').style.display = 'flex';
        document.querySelector('.help-center-home-footer').style.display = 'flex';
      }

      document.getElementById('description')
        .addEventListener('input', (changeEvent) => {
          document.querySelector('#contact-form .msg-length').innerText = `${changeEvent.currentTarget.value.length} of 1064`;
        });

      document.getElementById('contact-form')
        .addEventListener('submit', async (event) => {
          event.preventDefault();
          const submit = document.getElementById('submit');
          try {
            submit.disabled = true;
            submit.classList.add('disabled');
            submit.value = 'Sending Message';

            const payload = {
              email: document.getElementById('email').value,
              name: document.getElementById('name').value,
              subject: document.getElementById('topic').value,
              message: document.getElementById('description').value,
            };
            await fetch(this.props.formEndpoint, {
              method: 'POST',
              body: JSON.stringify(payload),
              headers: {
                'auth-token': '604c1f873cc26ca11261c6ff-9da6',
              },
            });
            document.querySelector('.gladly-contact .success')
              .classList
              .remove('hidden');

            // Identify user on Klaviyo
            window.klaviyoIdentify && window.klaviyoIdentify(payload.email);
          } catch (e) {
            console.error(e);
            document.querySelector('.gladly-contact .error')
              .classList
              .remove('hidden');
          } finally {
            submit.value = 'Done';
          }
        });

      // Add listeners for chat and feedback buttons
      document.querySelector('.js-help-center-live-chat-btn').addEventListener('click', async (event) => {
        document.querySelector('.js-chat-widget-modal-live-chat-btn').click();
      });

      document.querySelector('.js-help-center-feedback-btn').addEventListener('click', async (event) => {
        document.querySelector('.js-chat-widget-btn').click();
        document.querySelector('.js-chat-widget-modal-feedback-chat-btn').click();
      });

      // Hide loading message
      document.querySelector('.help-center-wrapper .loading').style.display = 'none';
    });

    // Load Help Center home page elements
    const targetNode = document.getElementById("gladly-help-center");
    const config = { childList: true };
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
          if (mutation.type === "childList") {
          // Update home page only
          const childPages = ['?a=', '?g=', '?s=', '?contact-form'];
          if (!childPages.some(query => window.location.search.includes(query))) {
            this.AddHCTitle();
            this.addSectionLinks();
            this.addFAQSubtitle();
          }
        }
      }
      // Update page title because is changed by Gladly
      document.title = this.props.originalTitle;
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
    // Don't disconnect observer or page will break
  }

  AddHCTitle() {
    // Add Help Center title and subtitle
    window.waitForElement('.gladlyHC-searchInput')
      .then(() => {
        const header = document.querySelector('h1.faq-title');
        if (!header) {
          const searchInput = document.querySelector('.gladlyHC-searchInput');
          const searchContainer = document.querySelector('.gladlyHC-searchContainer');

          const faqTitle = document.createElement('h1');
          faqTitle.classList.add('faq-title');
          faqTitle.innerText = 'Help Center';

          const faqSubtitle = document.createElement('p');
          faqSubtitle.classList.add('faq-title-copy');
          faqSubtitle.innerText = 'Our bras aren’t the only thing that offers support. Use the search bar to get instant answers to your questions.';

          searchContainer.insertBefore(faqTitle, searchInput);
          searchContainer.insertBefore(faqSubtitle, searchInput);
        }
      });
  }

  addSectionLinks() {
    // Add link to section title
    window.waitForElement('.gladlyHC-faqSection-list')
      .then(() => {
        const links = document.querySelector('.gladlyHC-faqSection a.section-link');
        if (!links) {
          const sections = document.querySelectorAll('.gladlyHC-faqSection');
          sections.forEach((section) => {
            const secTitle = section.querySelector('.gladlyHC-faqSection-header').innerText;
            const secHtml = section.innerHTML;
            section.innerHTML = `<a class="section-link" href="?g=${encodeURIComponent(secTitle)}" target="_self">${secHtml}</a>`;
          });
        }
      });
  }

  addFAQSubtitle() {
    // Add FAQ subtitle
    window.waitForElement('.gladlyHC-faqHeading')
      .then(() => {
        const subtitle = document.querySelector('.gladlyHC-faqContainer p.subtitle');
        if (!subtitle) {
          const faqContainer = document.querySelector('.gladlyHC-faqContainer');
          const faqSections = document.querySelector('.gladlyHC-faqSections');
          const subTitle = document.createElement('p');
          subTitle.classList.add('subtitle');
          subTitle.innerText = 'Select a category below – Find answers to commonly asked questions, we\'ve got the info you\'re looking for!';
          faqContainer.insertBefore(subTitle, faqSections);
        }
      });
  }
});
